import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Data
import propertyData from "pages/Home/sections/data/propertyData";

function HouseRules({ pricingConfig }) {
  const maxGuests = pricingConfig?.maxGuests || 16;
  const minNights = pricingConfig?.minimumNights || 5;
  const maxNights = pricingConfig?.maximumNights || 21;

  const rules = propertyData.houseRules.map((rule) =>
    rule.startsWith("Maximum occupancy") ? `Maximum occupancy: ${maxGuests} guests` : rule
  );

  return (
    <MKBox id="rules">
      <MKBox display={{ xs: "block", md: "flex" }} gap={8} justifyContent="center">
        {/* Check-in & Checkout */}
        <MKBox flex="0 0 auto" mb={{ xs: 3, md: 0 }}>
          <MKTypography variant="h5" mb={2}>
            <Icon sx={{ mr: 1, verticalAlign: "middle" }}>schedule</Icon>
            Check-in &amp; Checkout
          </MKTypography>
          <MKBox display="flex" mb={1}>
            <Icon sx={{ mr: 1, fontSize: "1rem", mt: 0.3, flexShrink: 0, color: "info.main" }}>
              login
            </Icon>
            <MKTypography variant="body2" color="dark">
              <strong>Check-in:</strong> After 2:00 PM
            </MKTypography>
          </MKBox>
          <MKBox display="flex" mb={1}>
            <Icon sx={{ mr: 1, fontSize: "1rem", mt: 0.3, flexShrink: 0, color: "info.main" }}>
              logout
            </Icon>
            <MKTypography variant="body2" color="dark">
              <strong>Checkout:</strong> Before 10:00 AM
            </MKTypography>
          </MKBox>
          <MKBox display="flex" mb={1}>
            <Icon sx={{ mr: 1, fontSize: "1rem", mt: 0.3, flexShrink: 0, color: "info.main" }}>
              night_shelter
            </Icon>
            <MKTypography variant="body2" color="dark">
              <strong>Minimum stay:</strong> {minNights} nights
            </MKTypography>
          </MKBox>
          <MKBox display="flex" mb={1}>
            <Icon sx={{ mr: 1, fontSize: "1rem", mt: 0.3, flexShrink: 0, color: "info.main" }}>
              date_range
            </Icon>
            <MKTypography variant="body2" color="dark">
              <strong>Maximum stay:</strong> {maxNights} nights
            </MKTypography>
          </MKBox>
        </MKBox>

        {/* House Rules */}
        <MKBox flex="0 0 auto">
          <MKTypography variant="h5" mb={2}>
            <Icon sx={{ mr: 1, verticalAlign: "middle" }}>gavel</Icon>
            House Rules
          </MKTypography>
          {rules.map((rule, i) => (
            <MKTypography key={i} variant="body2" color="dark" mb={1} display="flex">
              <Icon sx={{ mr: 1, fontSize: "1rem", mt: 0.3, flexShrink: 0 }}>check_circle</Icon>
              {rule}
            </MKTypography>
          ))}
        </MKBox>
      </MKBox>
    </MKBox>
  );
}

HouseRules.propTypes = {
  pricingConfig: PropTypes.object,
};

export default HouseRules;
